import { GrowthEntry } from 'spw-redux/modules/calculators/types';
import { isNil, last, range } from 'ramda';
import { ISpace } from 'spw-redux/modules/floorplan/types';
import { isProjectSpaceTypeSubcategory } from 'spw-redux/modules/space_types/types';

function getEntriesByGrowthRate(
  headcountSeatCountBase: number,
  headcountSeatCountGrowthRate: number
): (
  previousValue: GrowthEntry[],
  currentValue: number,
  currentIndex: number,
  array: number[]
) => GrowthEntry[] {
  return (entries: GrowthEntry[], year: number): GrowthEntry[] => {
    let valueBeforeRounding = 0;

    if (!entries.length) {
      valueBeforeRounding =
        headcountSeatCountBase * (1.0 + headcountSeatCountGrowthRate / 100.0);
    } else {
      const previousEntry = last(entries);
      valueBeforeRounding =
        previousEntry.value * (1.0 + headcountSeatCountGrowthRate / 100.0);
    }
    return [
      ...entries,
      {
        year,
        value: valueBeforeRounding,
      },
    ];
  };
}

function getEntriesByPreviousGrowthEntries(
  previousGrowthValues: number[]
): (
  previousValue: GrowthEntry[],
  currentValue: number,
  currentIndex: number,
  array: number[]
) => GrowthEntry[] {
  return (entries: GrowthEntry[], year: number, i: number): GrowthEntry[] => {
    return [
      ...entries,
      {
        year,
        value: previousGrowthValues?.[i],
      },
    ];
  };
}

export const calculateGrowthEntries = ({
  startYear,
  growthYears,
  headcountSeatCountGrowthRate,
  headcountSeatCountBase,
  growths,
}: {
  startYear: number;
  growthYears: number;
  headcountSeatCountBase: number;
  headcountSeatCountGrowthRate?: number;
  growths?: number[];
}) => {
  return range(startYear + 1, startYear + growthYears + 1).reduce(
    !isNil(headcountSeatCountGrowthRate)
      ? getEntriesByGrowthRate(
          headcountSeatCountBase,
          headcountSeatCountGrowthRate
        )
      : getEntriesByPreviousGrowthEntries(growths),
    []
  );
};
export const getYearHeadcount = (
  targetYear: number | string,
  growthEntries: GrowthEntry[]
) => {
  return growthEntries.find(
    (growthEntry: GrowthEntry) => growthEntry.year === targetYear
  )?.value;
};

export const getAlternativeWorkpointParams = (space: ISpace) => {
  if (space?.isAlternativeWorkpoint)
    return {
      alternativeWorkpointSeats: space.alternativeWorkpointSeats,
      isAlternativeWorkpoint: true,
    };
  if (
    space?.projectSpaceType &&
    isProjectSpaceTypeSubcategory(space.projectSpaceType.category) &&
    space.projectSpaceType.category.includeInTotalWorkSeats === false
  ) {
    return {
      alternativeWorkpointSeats: space.seatCount || 0,
      isAlternativeWorkpoint: true,
      isIndividualWorkspace: true,
    };
  }
  return { alternativeWorkpointSeats: null, isAlternativeWorkpoint: false };
};
